import React, { ComponentProps } from 'react';
import { SecondaryButton } from 'app/components/common/Button';

const Cancelled = ({ uncancel }: { uncancel: ComponentProps<typeof SecondaryButton>['onClick'] }) => (
  <div className="mt40 mh24 center-align">
    <p className="mt-3 mx-4">
      We are sorry to see you go. We have canceled your subscription. You will not be charged starting the next billing
      cycle and will lose access to the Maximus protocol.
    </p>
    <div className="m16">
      <SecondaryButton id="submit" text="Resume Account" onClick={uncancel} />
    </div>
  </div>
);

export default Cancelled;
